import { formatPhoneNumber } from "../utils/phoneUtils";

export const contactFields = [
  { key: "contactName", label: "Name" },
  { key: "contactTitle", label: "Title" },
  { key: "description", label: "Description" },
  { key: "emailAddress", label: "Email" },
  { key: "phone1", label: "Main Phone", type: "phone" },
  { key: "cellPhone", label: "Cell Phone", type: "phone" },
];

export const contactAdditionalFields = [
  { key: "emailAddress2", label: "Secondary Email" },
  { key: "phone2", label: "Secondary Phone", type: "phone" },
  { key: "cellPhone2", label: "Secondary Cell", type: "phone" },
  { key: "faxNumber", label: "Fax Number", type: "phone" },
];

export const initialContactFormData = {
  contactName: "",
  emailAddress: "",
  phone1: "",
  phone2: "",
  faxNumber: "",
  description: "",
  contactTitle: "",
  cellPhone: "",
  cellPhone2: "",
  emailAddress2: "",
};

export const contactRoles = [
  { roleKey: "mainContact", roleLabel: "Main Contact" },
  { roleKey: "agentContact", roleLabel: "Agent Contact" },
  { roleKey: "collectionsContact", roleLabel: "Collections Contact" },
];

export const contactTableHeaders = [
  {
    title: "Specifies the Contact's role for the Management Company.",
    label: "Role",
  },
  {
    title: "Specifies the Contact's name.",
    label: "Name",
  },
  {
    title: "Specifies the Contact's primary phone number.",
    label: "Main Phone",
  },
  {
    title: "Specifies the Contact's cellphone number.",
    label: "Cell Phone",
  },
  {
    title: "Specifies the Contact's primary email address.",
    label: "Email",
  },
];

export const contactViewColumns = [
  {
    key: "roleLabel",
    className: "px-2 py-1 border font-medium",
    accessor: (contact, roleLabel) => roleLabel,
  },
  {
    key: "contactName",
    className: "px-2 py-1 border",
    accessor: (contact) => (contact ? contact.contactName : ""),
  },
  {
    key: "phone1",
    className: "px-2 py-1 border",
    accessor: (contact) => (contact ? formatPhoneNumber(contact.phone1) : ""),
  },
  {
    key: "cellPhone",
    className: "px-2 py-1 border",
    accessor: (contact) =>
      contact ? formatPhoneNumber(contact.cellPhone) : "",
  },
  {
    key: "emailAddress",
    className: "px-2 py-1 border",
    accessor: (contact) => (contact ? contact.emailAddress : ""),
  },
];
